module.exports = __webpack_public_path__ + "media/honey-icons/icon-link-3783f9ac.svg";